import appConstants from "../../../../../../appConstants";
import { MultiSelectFilter } from "../../../../../dataGrid/columnFilters";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import ToolTip from "../../../../../common/StyledToolTip";

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration({ trailers, tractors }) {
    return GridConfig.getDefaultConfiguration(trailers, tractors);
  }

  static showTerminalStatus = (params) => {
    return (
      <ToolTip title={params.value ? "Enable" : "Disabled"}>
        <div style={{ padding: "5px 0px" }}>
          <FiberManualRecordIcon
            color={params.value ? "primary" : "secondary"}
          />
        </div>
      </ToolTip>
    );
  };
  // Utility to get equipment count for a specific type and equipment ID
  static getEquipmentCount = (equipmentType) => (equipmentId) => (params) => {
    if (!equipmentType || !equipmentId) return 0;
    const { data } = params;
    return data[equipmentType]?.[equipmentId] || 0;
  };

  // Build columns for equipment grid
  static buildEquipmentColumns = (equipments, type) => {
    if (!equipments) return [];

    return equipments.map((equipment) => ({
      headerName: equipment.name,
      headerClass: "groupHeaderChildren",
      valueGetter: GridConfig.getEquipmentCount(type)(equipment.id),
      minWidth: appConstants.columnWidth.W_150,
      filterFramework: MultiSelectFilter,
    }));
  };

  static buildColumnGroup = (title, children) => {
    return children.length
      ? [
          {
            headerName: title,
            headerClass: "groupHeaderParent",
            marryChildren: true,
            children,
          },
        ]
      : [];
  };

  static getDefaultConfiguration(trailers, tractors) {
    const trailersColumns = GridConfig.buildEquipmentColumns(
      trailers,
      "trailers"
    );
    const tractorsColumns = GridConfig.buildEquipmentColumns(
      tractors,
      "tractors"
    );

    return {
      title: appConstants.gridNames.DropYardGrid,
      keyColumn: "DropYardName",
      rowSelection: "multiple",
      rowDeselection: true,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columns: [
        {
          headerName: "Name",
          field: "dropYardName",
          minWidth: appConstants.columnWidth.W_200,
          filterFramework: MultiSelectFilter,
          tooltipField: "dropYardName",
        },
        {
          headerName: "Code",
          field: "dropYardCode",
          minWidth: appConstants.columnWidth.W_100,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Terminal",
          field: "terminalCode",
          minWidth: appConstants.columnWidth.W_100,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Address",
          field: "address",
          minWidth: appConstants.columnWidth.W_200,
          filterFramework: MultiSelectFilter,
          tooltipField: "address",
        },
        {
          headerName: "City",
          field: "city",
          minWidth: appConstants.columnWidth.W_120,
          filterFramework: MultiSelectFilter,
          tooltipField: "city",
        },
        {
          headerName: "State",
          field: "state",
          minWidth: appConstants.columnWidth.W_100,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Zip Code",
          field: "zip",
          minWidth: appConstants.columnWidth.W_120,
          filterFramework: MultiSelectFilter,
        },
        ...GridConfig.buildColumnGroup("Trailers", trailersColumns),
        ...GridConfig.buildColumnGroup("Tractors", tractorsColumns),
      ],
    };
  }
}
